export default "__VITE_ASSET__BycegacJ__"